// src/components/DatiTrasferta.jsx
// Blocco "Trasferta e orari" dei verbali: ora di inizio e fine, veicolo
// usato e km percorsi. I valori vivono nel formData del modulo che lo
// ospita (chiavi oraInizio, oraFine, veicoloId, kmPercorsi), cosi' partono
// insieme al resto del verbale, anche dalla coda offline.
//
// L'elenco dei veicoli si scarica una volta e resta in localStorage: senza
// rete il tecnico lo vede comunque.
import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/authFetch';

export const CAMPI_TRASFERTA = { oraInizio: '', oraFine: '', veicoloId: '', kmPercorsi: '' };

const CHIAVE_CACHE = 'ciesse-veicoli';

function leggiCache() {
  try {
    const salvati = JSON.parse(localStorage.getItem(CHIAVE_CACHE) || '[]');
    return Array.isArray(salvati) ? salvati : [];
  } catch {
    return [];
  }
}

export default function DatiTrasferta({ formData = {}, onChange, className = '' }) {
  const [veicoli, setVeicoli] = useState(leggiCache);

  useEffect(() => {
    let attivo = true;
    (async () => {
      try {
        const res = await authFetch('/api/veicoli');
        if (!res || !res.ok) return;
        const dati = await res.json();
        if (!attivo || !Array.isArray(dati)) return;
        setVeicoli(dati);
        try {
          localStorage.setItem(CHIAVE_CACHE, JSON.stringify(dati));
        } catch {
          /* quota piena o storage bloccato: pazienza */
        }
      } catch {
        /* offline: resta la copia in cache */
      }
    })();
    return () => {
      attivo = false;
    };
  }, []);

  const input =
    'mt-1 block w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500';

  const veicoloScelto = formData.veicoloId || '';
  const veicoloSconosciuto = veicoloScelto && !veicoli.some((v) => v._id === veicoloScelto);

  return (
    <section className={`bg-white rounded-2xl shadow-sm border border-gray-200 p-5 ${className}`.trim()}>
      <h3 className="font-semibold text-gray-800">Trasferta e orari</h3>
      <p className="text-xs text-gray-500 mb-3">
        Servono all'ufficio per stimare i costi di viaggio e le ore lavorate. Se lasci vuoti
        i km, vengono stimati dalla distanza sulla mappa.
      </p>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-600">Ora inizio</label>
          <input
            type="time"
            name="oraInizio"
            value={formData.oraInizio || ''}
            onChange={onChange}
            className={input}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600">Ora fine</label>
          <input
            type="time"
            name="oraFine"
            value={formData.oraFine || ''}
            onChange={onChange}
            className={input}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600">Veicolo</label>
          <select name="veicoloId" value={veicoloScelto} onChange={onChange} className={input}>
            <option value="">— nessuno / a piedi —</option>
            {veicoli.map((v) => (
              <option key={v._id} value={v._id}>
                {v.nome}
                {v.targa ? ` (${v.targa})` : ''}
              </option>
            ))}
            {veicoloSconosciuto && <option value={veicoloScelto}>Veicolo archiviato</option>}
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-600">Km percorsi (A/R)</label>
          <input
            type="number"
            inputMode="decimal"
            min="0"
            step="1"
            name="kmPercorsi"
            value={formData.kmPercorsi || ''}
            onChange={onChange}
            placeholder="stima automatica"
            className={input}
          />
        </div>
      </div>
    </section>
  );
}
